import script from "./SelectNoteGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectNoteGroup.vue?vue&type=script&setup=true&lang=js"

import "./SelectNoteGroup.vue?vue&type=style&index=0&id=441e5314&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-441e5314"]])

export default __exports__